// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc96a0d","455":"9c8b2673","488":"b0199390","977":"e590b13e"}[chunkId] + ".chunk.js";
};